import React from 'react';
import { MailIcon, AtSignIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  const links = [{
    icon: MailIcon,
    label: 'contacto@recursospracticysimple.com',
    href: 'mailto:contacto@recursospracticysimple.com'
  }, {
    icon: AtSignIcon,
    label: '@recursospracticysimple',
    href: 'https://instagram.com/recursospracticysimple'
  }, {
    icon: GlobeIcon,
    label: 'recursospracticysimple.com',
    href: 'https://recursospracticysimple.com'
  }];
  return <footer className="border-t border-line bg-night" data-id="element-98" data-mp="3ud7czjog16g0">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 md:grid-cols-[1.4fr_1fr]" data-id="element-99" data-mp="37fv17ktl04a">
        <div data-id="element-100" data-mp="3ldap3k9vobm0">
          <p className="font-display text-2xl font-bold text-bone" data-id="element-101" data-mp="3ldu3ir0bkhva">Megapack de Halloween™</p>
          <p className="mt-3 max-w-lg leading-relaxed text-mist" data-id="element-102" data-mp="3qc445h4tcaoa">
            El sistema de fiesta N°1 para familias argentinas. Porque Halloween merece más que globos naranjas y gomitas en un plato — y este año, tu fiesta va a ser la que todos recuerdan.
          </p>
        </div>
        <ul className="space-y-3" data-id="element-103" data-mp="3lalhzkmm4fwl">
          {links.map(({
          icon: Icon,
          label,
          href
        }) => <li key={label} data-id="element-104" data-mp="3gb8xh6j7rkx6">
              <a href={href} className="inline-flex items-center gap-2.5 break-all text-mist transition-colors duration-150 ease-out hover:text-bone" data-id="element-105" data-mp="3gc0ixoj3k29q">
                <Icon className="h-4 w-4 shrink-0 text-pumpkin-soft" aria-hidden="true" data-id="element-106" data-mp="3q83t9ho3r77r" />
                {label}
              </a>
            </li>)}
        </ul>
      </div>
      <p className="border-t border-line px-5 py-6 text-center text-sm text-mist" data-id="element-107" data-mp="33xbprfttmpc">
        © Recursos Practic &amp; Simple™ 2026 — Todos los derechos reservados.
      </p>
    </footer>;
}